<template>
  <VSpinner v-if="!product" class="offset-top-16 offset-bottom-17" />
  <article v-else>
    <div id="PRODUCT_ORDER_RESERVATION_CONFIRMATION" class="container-fixed">
      <!-- #53 -->
      <VProgress v-if="flags.progressBarEnabled" class="offset-top-2 offset-bottom-2" :steps="steps" active="substore.progress_confirmation" />

      <VSection cluster label="substore.product_reserved_for_you">
        <p v-html="product.texts.reservationHint"><!-- #165 --></p>
      </VSection>

      <!-- #102 -->
      <section class="offset-top-2 pull-right offset-right-1 button-bar">
        <router-link v-if="nextButtonType === PRODUCT_CATALOGUE" class="btn btn-default btn-brand" :to="{ name: PRODUCT_CATALOGUE }">
          {{ $t('substore.orderconfirmation_btn_next') }}
        </router-link>
        <router-link v-else-if="nextButtonType === STOCK" class="btn btn-default btn-brand" :to="{ name: STOCK }">
          {{ $t('common.navigation_STOCK') }}
        </router-link>
      </section>
    </div>

    <div class="container-fixed offset-top-6"> <VFootnotes :footnotes="footnotes" /><!-- #166 --> </div>
  </article>
</template>

<script>
import { mapGetters } from 'vuex';
import Proxy from '@/proxies/ReservationConfirmationProxy';
import Transformer from '@/transformers/ProductReservationConfirmationTransformer';
import Footnotes from '@/utils/Footnotes';
import TitleMixin from '@/mixins/title';
import OrderStepsMixin from '@/mixins/orderSteps';
import VSpinner from '@/components/Spinner';
import VSection from '@/components/Section';
import { PRODUCT_CATALOGUE, STOCK } from '@route-types';

export default {
  name: 'ProductReservationConfirmation',

  components: {
    VSpinner,
    VSection,
    VProgress: () => import('@/components/Progress'),
    VFootnotes: () => import('@/components/UI/Footnotes'),
  },

  mixins: [TitleMixin, OrderStepsMixin],

  props: {
    subscriptionTemplateId: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      PRODUCT_CATALOGUE,
      STOCK,

      product: null,
      footnotes: null,
      optin: false, // TODO
      flags: {
        progressBarEnabled: null,
        orderSelectionSkipped: null,
        isOnlyReservationAllowed: null,
        isPurchaseRedirectRequired: null,
        thirdPartyAuthentication: null,
        isFinalizationAllowed: null,
        isCompleteOrderAllowed: null,
        subscriptionBookedByExtern: null,
        subscriptionBeginIsRunning: null,
        isFinalization: null,
        isResumingSubscription: null,
      },
    };
  },

  computed: {
    ...mapGetters('system', ['hasAccessCatalogue', 'hasAccessStockOverview']),

    nextButtonType() {
      if (this.hasAccessCatalogue && (!this.flags.subscriptionBookedByExtern /* DescElemToBeSetToFinalize */ || !this.hasAccessStockOverview)) {
        return PRODUCT_CATALOGUE;
      } else if (this.hasAccessStockOverview) {
        return STOCK;
      }
      return null;
    },
  },

  async created() {
    const response = await new Proxy().find(this.subscriptionTemplateId);

    if (response.head.fault !== null) throw new Error(response.head.fault);

    this.footnotes = new Footnotes();
    this.product = Transformer.fetch(response.data.product, this.footnotes);

    // TODO pl: put flags into mixin?
    Object.keys(this.flags).forEach(key => {
      this.flags[key] = response.data[key];
    });
  },
};
</script>

<style scoped>
.button-bar > span {
  position: relative;
  top: 1px;
  display: inline-block;
}
</style>
